module.exports = __webpack_public_path__ + "static/media/TN-Men-Tshirts-v2.0.1555c82e.svg";